var OrderBundleOption = /*@__PURE__*/ (function () {
    function OrderBundleOption() {
    }
    OrderBundleOption.prototype.getId = function () {
        return this.id;
    };
    OrderBundleOption.prototype.setId = function (id) {
        this.id = id;
        return this;
    };
    return OrderBundleOption;
}());
export { OrderBundleOption };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/order/order.bundle-option.ts
// module id = null
// module chunks = 